<section class="toggle--container">
  <label [for]="field().key" [formGroup]="parentForm()" class="toggle-label">
    <div class="label--container body1">
      {{ field().label }}
      @if (field().required) {
        <span class="required" aria-required="true"> * </span>
      }
    </div>
    <mat-slide-toggle
      [id]="field().key"
      [formControlName]="field().key"
      ngDefaultControl
      color="primary"
    ></mat-slide-toggle>
  </label>
  @if (tooltipText()) {
    <div class="tooltip" role="tooltip">
      <mat-icon [class.disabled]="parentForm()?.controls[field().key]?.disabled"
        >info</mat-icon
      >
      <div class="top">
        {{ tooltipText() }}
        <i></i>
      </div>
      <div class="tooltip-accessibility">
        {{ tooltipText() }}
      </div>
    </div>
  }
</section>
